export const IS_OPEN = "IS_OPEN";
export const GET_URL_PHOTO = "GET_URL_PHOTO";